<template>
  <div>
    <!-- <left-menu-admin menuActive="0" :sessionData="session"></left-menu-admin> -->
    <v-main>
      <div class="pl-12 pr-12 col-md-12 ml-sm-auto col-lg-12 px-4">
        <v-row>
          <v-col cols="6" class="text-left">
            <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
          </v-col>
          <v-col cols="6" class="v-margit_button text-right">
            <v-btn
              color="#1B437C"
              depressed
              dark
              @click=";(dialogAdd = true), validate('ADD')"
            >
              <v-icon left>mdi-text-box-plus</v-icon>
              เพิ่ม
            </v-btn>
          </v-col>
        </v-row>
        <v-row>
          <!-- ADD -->
          <v-dialog v-model="dialogAdd" persistent :max-width= "resCol === '12' ? '' : '40%'" :fullscreen="resCol === '12' ? true : false">
            <v-card>
              <v-form ref="form_add" v-model="validAdd" lazy-validation>
                <v-card-text>
                  <v-container>
                    <v-row style="padding-top:15px;padding-bottom:15px">
                      <v-col style="padding: 15px 16px 0px">
                        <h3>เพิ่มข้อมูลโปรโมชั่น</h3>
                      </v-col>
                      <v-col class="text-right">
                        <v-btn
                          small
                          fab
                          color="#E0E0E0"
                          @click=";(dialogAdd = false), clearData()"
                        >
                          <v-icon color="#173053">mdi-close</v-icon>
                        </v-btn>
                      </v-col>
                    </v-row>
                    <v-row justify="center">
                      <v-col>
                        <v-img
                            aspect-ratio="6"
                            contain
                            :src="formAdd.pictureUrlPreview"
                            v-if="formAdd.pictureUrlPreview"
                          ></v-img>
                          <br />
                          <v-file-input
                            required
                            counter
                            show-size
                            :rules="[rules.required]"
                            accept="image/png, image/jpeg, image/bmp"
                            prepend-icon="mdi-camera"
                            label="Image"
                            @change="selectImg"
                            v-model="filesAdd"
                          ></v-file-input>
                          <v-text-field
                              v-model="formAdd.promotionName"
                              label="ชื่อโปรโมชั่น"
                              dense
                              outlined
                              required
                              :rules="[rules.required]"
                            ></v-text-field>
                            <v-text-field
                              v-model="formAdd.promotionNameEng"
                              label="ชื่อโปรโมชั่นภาษาอังกฤษ"
                              dense
                              outlined
                              required
                            ></v-text-field>
                            <!-- <v-text-field
                              v-model="formAdd.promotionSubName"
                              label="ชื่อรองโปรโมชั่น"
                              dense
                              outlined
                              required
                              :rules="[rules.required]"
                            ></v-text-field> -->
                            <v-select
                            v-model="formAdd.packageId"
                            :items="this.package"
                            item-value="packageId"
                            item-text="packageName"
                            label="ผูกแพ็กเกจ"
                            dense
                              outlined
                          >
                          </v-select>
                          <v-textarea
                              auto-grow
                              rows="2"
                              name="input-7-4"
                              label="รายละเอียด"
                              dense
                              outlined
                              required
                              :rules="[rules.required]"
                              v-model="formAdd.promotionDetails"
                            ></v-textarea>
                            <v-textarea
                              auto-grow
                              rows="2"
                              name="input-7-4"
                              label="รายละเอียดภาษาอังกฤษ"
                              dense
                              outlined
                              required
                              v-model="formAdd.promotionDetailsEng"
                            ></v-textarea>
                            <v-radio-group
                              v-model="formAdd.limitExpri"
                              row
                              style="margin-top:0;padding-top:0"
                            >
                              <v-radio
                                label="ไม่กำหนดวันหมดอายุ"
                                value="ไม่กำหนดวันหมดอายุ"
                              ></v-radio>
                               <v-radio
                                label="กำหนดวันหมดอายุ"
                                value="กำหนดวันหมดอายุ"
                              ></v-radio>
                            </v-radio-group>
                            <v-menu
                            v-if="formAdd.limitExpri === 'กำหนดวันหมดอายุ'"
                            v-model="menu1"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="290px"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                v-if="formAdd.limitExpri === 'กำหนดวันหมดอายุ'"
                                color="primary"
                                v-model="formAdd.promotionExpiryDate"
                                v-bind="attrs"
                                v-on="on"
                                required
                                outlined
                                dense
                                label="วันหมดอายุ"
                                :rules="[rules.required]"
                              ></v-text-field>
                            </template>
                            <v-date-picker
                            v-if="formAdd.limitExpri === 'กำหนดวันหมดอายุ'"
                              :min="nowDate"
                              v-model="formAdd.promotionExpiryDate"
                              @input="menu1 = false"
                              show-current
                            >
                            </v-date-picker>
                          </v-menu>
                          <v-btn
                          style="margin-top:10px"
                              elevation="2"
                              block
                              color="#173053"
                              dark
                              :loading="loadingAdd"
                              @click="addData()"
                            >
                              บันทึก
                            </v-btn>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
              </v-form>
            </v-card>
          </v-dialog>
          <!-- end add -->

          <!-- edit -->
          <v-dialog v-model="dialogEdit" persistent :max-width= "resCol === '12' ? '' : '40%'" :fullscreen="resCol === '12' ? true : false">
            <v-card>
              <v-form ref="form_update" v-model="validUpdate" lazy-validation>
                <v-card-text>
                  <v-container>
                    <v-row style="padding-top:15px;padding-bottom:15px">
                      <v-col style="padding: 15px 16px 0px">
                        <h3>แก้ไขข้อมูลโปรโมชั่น</h3>
                      </v-col>
                      <v-col class="text-right">
                        <v-btn
                          small
                          fab
                          color="#E0E0E0"
                          @click=";(dialogEdit = false), clearDataUpdate()"
                        >
                          <v-icon color="#173053">mdi-close</v-icon>
                        </v-btn>
                      </v-col>
                    </v-row>
                    <v-row justify="center">
                      <v-col>
                        <v-img
                            aspect-ratio="6"
                            contain
                            :src="formUpdate.pictureUrlPreview"
                            v-if="formUpdate.pictureUrlPreview"
                          ></v-img>
                          <br />
                          <v-file-input
                              required
                              counter
                              show-size
                              :rules="[rules.resizeImag]"
                              accept="image/png, image/jpeg, image/bmp"
                              prepend-icon="mdi-camera"
                              label="Image"
                              @change="selectImgUpdate"
                              v-model="filesUpdate"
                            ></v-file-input>
                          <v-text-field
                              v-model="formUpdate.promotionName"
                              label="ชื่อโปรโมชั่น"
                              dense
                              outlined
                              required
                              :rules="[rules.required]"
                            ></v-text-field>
                            <v-text-field
                              v-model="formUpdate.promotionNameEng"
                              label="ชื่อโปรโมชั่นภาษาอังกฤษ"
                              dense
                              outlined
                              required
                            ></v-text-field>
                            <!-- <v-text-field
                              v-model="formUpdate.promotionSubName"
                              label="ชื่อรองโปรโมชั่น"
                              dense
                              outlined
                              required
                              :rules="[rules.required]"
                            ></v-text-field> -->
                            <v-select
                            v-model="formUpdate.packageId"
                            :items="this.package"
                            clearable
                            item-value="packageId"
                            item-text="packageName"
                            label="ผูกแพ็กเกจ"
                            cleara
                            dense
                              outlined
                          >
                          </v-select>
                          <v-textarea
                              auto-grow
                              name="input-7-1"
                              placeholder="รายละเอียด"
                              label="รายละเอียด"
                              outlined
                              v-model="formUpdate.promotionDetails"
                            ></v-textarea>
                            <v-textarea
                              auto-grow
                              name="input-7-1"
                              placeholder="รายละเอียดภาษาอังกฤษ"
                              label="รายละเอียดภาษาอังกฤษ"
                              outlined
                              v-model="formUpdate.promotionDetailsEng"
                            ></v-textarea>
                            <v-radio-group
                              v-model="formUpdate.limitExpri"
                              row
                              style="margin-top:0;padding-top:0"
                            >
                              <v-radio
                                label="ไม่กำหนดวันหมดอายุ"
                                value="ไม่กำหนดวันหมดอายุ"
                              ></v-radio>
                               <v-radio
                                label="กำหนดวันหมดอายุ"
                                value="กำหนดวันหมดอายุ"
                              ></v-radio>
                            </v-radio-group>
                            <v-menu
                            v-if="formUpdate.limitExpri === 'กำหนดวันหมดอายุ'"
                            v-model="menu2"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="290px"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                color="primary"
                                v-model="formUpdate.promotionExpiryDate"
                                v-bind="attrs"
                                v-on="on"
                                required
                                outlined
                                dense
                                label="วันหมดอายุ"
                                :rules="[rules.required]"
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              :min="nowDate"
                              v-model="formUpdate.promotionExpiryDate"
                              @input="menu2 = false"
                              show-current
                            >
                            </v-date-picker>
                          </v-menu>
                          <v-btn
                              elevation="2"
                              block
                              color="#173053"
                              dark
                              :loading="loadingAdd"
                              @click="editData()"
                            >
                              บันทึก
                            </v-btn>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
              </v-form>
            </v-card>
          </v-dialog>
          <!-- end -->

          <!-- delete -->
          <v-dialog v-model="dialogDelete" persistent max-width="40%">
            <v-card>
              <v-container>
              <v-card-title style="padding-bottom: 10px;">
                <span class="headline">ลบข้อมูลนี้</span>
              </v-card-title>
              <v-card-text>
                  <v-row>
                    <v-col cols="12" style="padding: 20px 15px;">
                      <v-text-field
                        label="ชื่อโปรโมชั่น"
                        v-model="formUpdate.promotionName"
                        readonly
                        dense
                        outlined
                      ></v-text-field>
                    </v-col>
                  </v-row>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  elevation="2"
                  dark
                  class="btn-color"
                  @click="dialogDelete = false"
                >
                  <v-icon left> mdi-cancel</v-icon>
                  ปิด
                </v-btn>
                <v-btn
                  elevation="2"
                  dark
                  color="red darken-1"
                  @click="deleteData()"
                >
                  <v-icon left>mdi-checkbox-marked-circle</v-icon>
                  ลบ
                </v-btn>
              </v-card-actions>
              </v-container>
            </v-card>
          </v-dialog>
          <!-- end delete -->

          <!-- data table -->
          <v-col cols="12">
            <div class="mb-4" style="text-align: end;">
              <v-btn style="color: white
               !important;" color="#1c437d" @click="sortActive = true, getPackage()"><v-icon>mdi-sort</v-icon>เรียงลำดับข้อมูล</v-btn>
            </div>
            <v-card elevation="7" v-if="dataReady">
              <v-card-title>
                <v-text-field
                  v-model="searchAll2"
                  append-icon="mdi-magnify"
                  label="Search"
                  single-line
                  hide-details
                ></v-text-field>
              </v-card-title>
              <v-card-text>
                <v-data-table
                  v-if="sortActive"
                  :items="dataSort"
                  :items-per-page="-1"
                  hide-default-footer
                >
                  <template #item="{ item, index }">
                      <tr
                      :key="item.id"
                      :draggable="true"
                      @dragstart="dragStart(index)"
                      @dragover.prevent
                      @drop="drop(index)"
                    >
                      <td>{{ index + 1 + "." }} {{ item.promotionName }}</td>
                    </tr>
                  </template>
                  <template v-slot:footer>
                      <div style="padding: 20px !important">
                        <VBtn
                          width="80px"
                          variant="flat"
                          color="primary"
                          type="submit"
                          class="mr-4"
                          v-if="dataSort.length > 0"
                          @click="saveSort()"
                        >
                          บันทึก
                        </VBtn>
                        <VBtn
                          color="secondary"
                          width="80px"
                          variant="outlined"
                          @click="sortActive = false"
                        >
                          ยกเลิก
                        </VBtn>
                      </div>
                    </template>
                </v-data-table>
                <v-data-table
                  v-if="!sortActive"
                  :headers="columns"
                  :items="dataItem"
                  :search="searchAll2"
                  :items-per-page="10"
                >
                  <template v-slot:[`item.promotionExpiryDate`]="{ item }">
                    {{ thaiFormattedDate(item.promotionExpiryDate) }}
                  </template>
                  <template v-slot:[`item.LAST_DATE`]="{ item }">
                    {{ thaiFormattedDate(item.LAST_DATE) }}
                  </template>
                  <template v-slot:[`item.promotionPicture`]="{ item }">
                    <v-avatar color="primary" size="40">
                      <img :src="item.promotionPicture" alt="img"
                    /></v-avatar>
                  </template>
                  <template v-slot:[`item.action`]="{ item }">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          v-bind="attrs"
                          v-on="on"
                          class="btn-color"
                          fab
                          x-small
                          dark
                          @click.stop="getDataById(item, 'edit')"
                        >
                          <v-icon dark> mdi-tools </v-icon>
                        </v-btn>
                      </template>
                      <span>แก้ไขข้อมูล</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          v-bind="attrs"
                          v-on="on"
                          color="red"
                          dark
                          fab
                          x-small
                          @click.stop="getDataById(item, 'delete')"
                        >
                          <v-icon> mdi-delete </v-icon>
                        </v-btn>
                      </template>
                      <span>ลบข้อมูล</span>
                    </v-tooltip>
                  </template>
                </v-data-table>
              </v-card-text>
            </v-card>
            <div v-if="!dataReady" class="text-center">
              <v-progress-circular
                indeterminate
                color="primary"
              ></v-progress-circular>
            </div>
          </v-col>
          <!-- end data table -->
        </v-row>
      </div>
    </v-main>
  </div>
</template>
<script>
import axios from 'axios' // api
import adminLeftMenu from '../Sidebar.vue' // เมนู
import moment from 'moment' // แปลง date

export default {
  components: {
    'left-menu-admin': adminLeftMenu
  },
  computed: {
    resCol () {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
          return '12'
        case 'sm':
          return '12'
        case 'md':
          return '6'
        case 'lg':
          return '6'
        case 'xl':
          return '6'
      }
      console.log(
        'this.$vuetify.breakpoint.name',
        this.$vuetify.breakpoint.name
      )
    }
  },
  data () {
    return {
      PK: '',
      path: '/promotion/', // Path Model
      returnLink: '/Master/Promotion',
      // Menu Config
      breadcrumbs: [
        {
          text: 'Home',
          disabled: false,
          href: '/Core/Home'
        },
        {
          text: 'โปรโมชั่น',
          disabled: false,
          href: '/Master/Promotion'
        }
      ],
      // End Menu Config
      dataReady: true,
      dateTime: '', // Generate DateTime
      date: new Date().toISOString().substr(0, 10),
      // Dialog Config ADD EDIT DELETE IMPORT
      menu1: false,
      menu2: false,
      dialogAdd: false,
      dialogEdit: false,
      packageId: null,
      dialogDelete: false,
      session: this.$session.getAll(),
      sortActive: false,
      // Search All
      searchAll: '',
      searchAll2: '',
      filesAdd: null,
      filesUpdate: null,
      nowDate: new Date().toISOString().slice(0, 10),
      formAdd: {
        promotionName: '',
        promotionSubName: '',
        promotionPicture: '',
        promotionDetails: '',
        promotionExpiryDate: '',
        limitExpri: 'ไม่กำหนดวันหมดอายุ',
        CREATE_USER: '',
        LAST_USER: '',
        pictureUrlPreview: '',
        packageId: null,
        shopId: this.$session.getAll().data.shopId
      },
      formUpdate: {
        id: '',
        promotionName: '',
        promotionSubName: '',
        promotionPicture: '',
        promotionDetails: '',
        promotionExpiryDate: '',
        limitExpri: '',
        CREATE_USER: '',
        LAST_USER: '',
        pictureUrlPreview: '',
        shopId: '',
        packageId: ''
      },
      dragIndexItem: null,
      dataSort: null,
      rules: {
        required: value => !!value || 'กรุณากรอก.'
      },
      // End Form Config ADD EDIT
      // Data Table Config
      columns: [
        { text: 'รูป', value: 'promotionPicture' },
        { text: 'ชื่อโปรโมชั่น', value: 'promotionName' },
        { text: 'ชื่อรองโปรโมชั่น', value: 'promotionSubName' },
        { text: 'รายละเอียด', value: 'promotionDetails' },
        { text: 'วันหมดอายุ', value: 'promotionExpiryDate' },
        { text: 'วันอัพเดท', value: 'LAST_DATE' },
        { text: 'จัดการ', value: 'action', sortable: false, align: 'center' }
      ],
      dataItem: [],
      validAdd: true,
      validUpdate: true,
      dataLevel: [],
      // End Data Table Config
      loadingAdd: false,
      loadingEdit: false,
      package: null
    }
  },
  beforeCreate () {
    if (!this.$session.exists()) {
      this.$router.push('/Core/Login')
    }
  },
  async mounted () {
    // this.getGetToken(this.DNS_IP)
    this.dataReady = false
    // Get Data
    await this.getDataGlobal(
      this.DNS_IP,
      this.path,
      this.session.data.shopId,
      this.returnLink
    )
    await this.getPackage()
    this.dataSort = this.dataItem
  },
  methods: {
    // getNew () {

    // },
    async yoyoy () {
      await axios
        .get(
          // eslint-disable-next-line quotes
          'https://zsplash.net/noel/token',
          {
            headers: {
              'userName': 'betask',
              'password': 'psVXBpKuP#Ms*f2cGSX%prcrTKj*',
              'grant_type': 'password'
            }
          }
        )
        .then(async response => {
          console.log(response)
        })
        // eslint-disable-next-line handle-callback-err
        .catch(error => {
        })
    },
    async saveSort () {
      console.log('dataSort.value', this.dataSort)
      let dataUpdate = []
      this.dataSort.forEach((item, index) => {
        let data = {
          id: item.id,
          sort: (index + 1)
        }
        dataUpdate.push(data)
      })
      await axios.post(
        this.DNS_IP + '/promotion/editMulti', dataUpdate
      ).then(async res => {
        if (res) {
          this.$swal('เรียบร้อย', 'แก้ไขข้อมูล เรียบร้อย', 'success')
        } else {
          this.$swal('ผิดพลาด', 'แก้ไขข้อมูล ไม่สำเร็จ', 'error')
        }
        this.sortActive = false

        await this.getDataGlobal(
          this.DNS_IP,
          this.path,
          this.session.data.shopId,
          this.returnLink
        )
      })
      console.log('dataSort.value', dataUpdate)
    },
    dragStart (index) {
      this.dragIndexItem = index
    },
    drop (index) {
      let tempArr = [...this.dataSort]
      tempArr.splice(this.dragIndexItem, 1)
      tempArr.splice(index, 0, this.dataSort[this.dragIndexItem])
      this.dataSort = tempArr
    },
    async getPackage () {
      await axios.get(
        this.DNS_IP + `/package/get?shopId=${this.session.data.shopId}`
      ).then(res => {
        if (res.data.status === false) {
          this.package = []
        } else {
          this.package = res.data
        }
      })
      // let res = await axios.get(
      //   this.DNS_IP + `/package/get?shopId=${this.session.data.shopId}`
      // )
      // this.package = res.data
      // console.log('this.package', this.package)
    },
    selectImgUpdate () {
      if (this.filesUpdate) {
        this.formUpdate.pictureUrlPreview = URL.createObjectURL(
          this.filesUpdate
        )
      } else {
        this.formUpdate.pictureUrlPreview = ''
      }
      // console.log(event)
    },
    selectImg () {
      if (this.filesAdd) {
        this.formAdd.pictureUrlPreview = URL.createObjectURL(this.filesAdd)
      } else {
        this.formAdd.pictureUrlPreview = ''
      }
      // console.log(event)
    },
    validate (Action) {
      switch (Action) {
        case 'ADD':
          this.$nextTick(() => {
            let self = this
            self.$refs.form_add.validate()
          })
          break
        case 'UPDATE':
          this.$nextTick(() => {
            let self = this
            self.$refs.form_update.validate()
          })
          break

        default:
          break
      }
    },
    async getDataById (item, type) {
      //
      //
      // สำหรับ เรียกข้อมูล ใส่ form Update / Delete
      //
      //
      // Get ID /main.js
      this.dataReady = false
      await this.getDataByIdGlobal(
        this.DNS_IP,
        this.path,
        'id',
        item.id,
        this.returnLink
      )
      this.formUpdate.pictureUrlPreview = this.formUpdate.promotionPicture
      console.log(typeof this.formUpdate.promotionExpiryDate)
      if (!this.formUpdate.promotionExpiryDate) {
        // alert(this.formUpdate.promotionExpiryDate)
        this.formUpdate.promotionExpiryDate = ''
      } else {
        // alert('sqwsqsws')
        this.formUpdate.promotionExpiryDate = moment(
          String(this.formUpdate.promotionExpiryDate)
        ).format('YYYY-MM-DD')
      }
      console.log('type', typeof (this.formUpdate.packageId))
      if (this.formUpdate.packageId) {
        this.formUpdate.packageId = parseInt(this.formUpdate.packageId)
      }
      if (type === 'edit') {
        this.dialogEdit = true
        this.validate('UPDATE')
      } else if (type === 'delete') {
        this.dialogDelete = true
      }
    },
    async addData () {
      this.dataReady = false
      this.$swal({
        title: 'ต้องการ เพิ่มข้อมูล ใช่หรือไม่?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      })
        .then(async result => {
          this.loadingAdd = true
          this.formAdd.CREATE_USER = this.session.data.userName
          this.formAdd.LAST_USER = this.session.data.userName
          if (this.formAdd.limitExpri === 'ไม่กำหนดวันหมดอายุ') {
            delete this.formAdd['promotionExpiryDate']
            // this.formAdd.promotionExpiryDate = null
          }
          const _this = this
          let params = new FormData()
          params.append('file', this.filesAdd)

          await axios
            .post(this.DNS_IP + `/file/upload/promotion`, params)
            .then(function (response) {
              _this.formAdd.promotionPicture = response.data
              console.log('url Pic', response.data)
            })
          delete this.formAdd['pictureUrlPreview']
          if (!this.formAdd.packageId) {
            delete this.formAdd['packageId']
          }
          console.log('this.formAdd', this.formAdd)
          await axios
            .post(
              this.DNS_IP + this.path + 'add',
              this.formAdd
            )
            .then(async response => {
              // Debug response
              console.log('addDataGlobal DNS_IP + PATH + "add"', response)

              this.$swal('เรียบร้อย', 'เพิ่มข้อมูล เรียบร้อย', 'success')
              // Close Dialog
              this.dialogAdd = false

              // Load Data
              await this.clearData()
              this.filesAdd = null
              await this.getDataGlobal(
                this.DNS_IP,
                this.path,
                this.session.data.shopId,
                this.returnLink
              )
              this.loadingAdd = false
            })
            // eslint-disable-next-line handle-callback-err
            // .catch(error => {
            //   console.log('error function addDataGlobal : ', error)
            //   this.$router.push(
            //     '/system/Errorpage?returnLink=' + this.returnLink
            //   )
            //   this.dataReady = true
            // })
        })
        // .catch(error => {
        //   console.log('error function addData : ', error)
        //   this.dataReady = true
        // })
    },
    async editData () {
      // this.editDataGlobal(this.DNS_IP, this.path, this.PK, this.formUpdateItem)
      this.dataReady = false

      this.$swal({
        title: 'ต้องการ แก้ไขข้อมูล ใช่หรือไม่?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      })
        .then(async result => {
          this.loadingEdit = true
          this.formUpdate.LAST_USER = this.session.data.userName
          var ID = this.formUpdate.id
          if (this.filesUpdate) {
            const _this = this
            let params = new FormData()
            params.append('file', this.filesUpdate)
            await axios
              .post(this.DNS_IP + `/file/upload/promotion`, params)
              .then(function (response) {
                _this.formUpdate.promotionPicture = response.data
                console.log('url Pic', response.data)
              })
          } else {
            this.formUpdate.promotionPicture = this.formUpdate.pictureUrlPreview
          }
          if (this.formUpdate.limitExpri === 'ไม่กำหนดวันหมดอายุ') {
            this.formUpdate.promotionExpiryDate = ''
          }
          if (this.formUpdate.packageId) {
            this.formUpdate.packageId = this.formUpdate.packageId
          } else {
            this.formUpdate.packageId = null
          }
          delete this.formUpdate['pictureUrlPreview']
          delete this.formUpdate['id']
          delete this.formUpdate['LAST_DATE']
          delete this.formUpdate['CREATE_DATE']
          delete this.formUpdate['CREATE_USER']
          delete this.formUpdate['packageName']
          delete this.formUpdate['limitPackage']
          delete this.formUpdate['packageCount']
          delete this.formUpdate['packagePrice']
          delete this.formUpdate['useInBranch']
          console.log('this.formUpdate', this.formUpdate)
          await axios
            .post(
              // eslint-disable-next-line quotes
              this.DNS_IP + this.path + 'edit/' + ID,
              this.formUpdate
            )
            .then(async response => {
              // Debug response
              console.log('editDataGlobal DNS_IP + PATH + "edit"', response)

              this.$swal('เรียบร้อย', 'แก้ไขข้อมูล เรียบร้อย', 'success')
              // Close Dialog
              this.dialogEdit = false
              // Load Data
              // await this.reloadData()
              await this.clearDataUpdate()
              this.filesUpdate = null
              await this.getDataGlobal(
                this.DNS_IP,
                this.path,
                this.session.data.shopId,
                this.returnLink
              )
              this.loadingEdit = false
            })
            .catch(error => {
              this.dataReady = true
              console.log('error function editDataGlobal : ', error)
              this.$router.push(
                '/system/Errorpage?returnLink=' + this.returnLink
              )
            })
        })
        .catch(error => {
          this.dataReady = true
          console.log('error function editDataGlobal : ', error)
        })
    },
    async deleteData () {
      this.formUpdate.LAST_USER = this.session.data.userName
      console.log('DELETE PK : ', this.formUpdate.id)
      this.dataReady = false
      await this.deleteDataGlobal(
        this.DNS_IP,
        this.path,
        this.formUpdate.id,
        this.session.data.shopId,
        '',
        this.returnLink
      )
    },
    async clearData () {
      this.formAdd.promotionName = ''
      this.formAdd.promotionNameEng = ''
      this.formAdd.promotionSubName = ''
      this.formAdd.promotionPicture = ''
      this.formAdd.promotionDetails = ''
      this.formAdd.promotionDetailsEng = ''
      this.formAdd.promotionExpiryDate = ''
      this.formAdd.CREATE_USER = ''
      this.formAdd.LAST_USER = ''
      this.formAdd.pictureUrlPreview = ''
      this.formAdd.packageId = null
      this.formAdd.shopId = this.$session.getAll().data.shopId
    },
    async clearDataUpdate () {
      this.formUpdate.id = ''
      this.formUpdate.promotionName = ''
      this.formUpdate.promotionNameEng = ''
      this.formUpdate.promotionSubName = ''
      this.formUpdate.promotionPicture = ''
      this.formUpdate.promotionDetails = ''
      this.formUpdate.promotionDetailsEng = ''
      this.formUpdate.promotionExpiryDate = ''
      this.formUpdate.CREATE_USER = ''
      this.formUpdate.LAST_USER = ''
      this.formUpdate.pictureUrlPreview = ''
      this.formUpdate.shopId = ''
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Master/Promotion.vue